import axios from "axios";

const BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://express-server-gules-mu.vercel.app";

// Funzione per recuperare il menu giornaliero
export async function fetchDailyMenu() {
    try {
        const response = await axios.get(`${BASE_URL}/daily-menu`);
        return response.data;
    } catch (error) {
        console.error('Error fetching daily menu:', error);
        return null;
    }
}

// Funzione per aggiornare il menu giornaliero
export async function updateDailyMenu(updatedMenuData) {
    try {
        const response = await axios.put(`${BASE_URL}/daily-menu/1`, updatedMenuData);
        return response.data;
    } catch (error) {
        console.error('Error updating daily menu:', error);
        return null;
    }
}

// Funzione per verificare se il menu giornaliero esiste
export async function checkIfMenuExists() {
    try {
        const response = await axios.get(`${BASE_URL}/daily-menu`);
        const responseData = response.data;

        if (Array.isArray(responseData) && responseData.length > 0) {
            const thereIs = responseData[0].there_is;
            return thereIs;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error checking if daily menu exists:', error);
        return false;
    }
}



